import { yupResolver } from '@hookform/resolvers'
import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { SearchHeader } from '@ifca-root/react-component/src/components/Header/SearchHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import IconText from '@ifca-root/react-component/src/components/Typography/IconText'
import {
  Box,
  Checkbox,
  Button,
  CircularProgress,
  FormControlLabel,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
  Switch,
  TextField,
} from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'
import { Autocomplete } from '@material-ui/lab'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { AccCodeDropdownFullWidth } from 'components/Dropdown/AccCodeDropdown'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AccountType,
  AcctPermission,
  CommonStatus,
  GetBillItemDataDocument,
  GetBillItemDocument,
  RecordStatus,
  useCreateBillItemMutation,
  useDeleteBillItemMutation,
  useGetAllBillItemLazyQuery,
  useGetClassificationCodeQuery,
  useGetHomeSummaryQuery,
  useGetMasterCoaCodeQuery,
  useGetMsicCodeQuery,
  useGetTaxSchemeNewListingQuery,
  useImportBillItemExcelMutation,
  useUpdateBillItemMutation,
} from 'generated/graphql'
import { useMenuOption } from 'helpers/CustomHooks/useMenuOption'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { useFuseSearch } from 'helpers/Hooks/useSearch'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { CommonYupValidation } from 'helpers/YupSchema/yup'
import React, { useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory, useParams } from 'react-router'
import * as yup from 'yup'
import ExcelIcon from '@account-root/account-react/src/assets/icons/excel.svg'
import UploadIcon from '@material-ui/icons/Publish'
import { ItemExcelInput } from '@account-root/procurement-react/src/containers/GeneralSettingModule/Item/ItemImportExcelDialog'
import { useExcelUploadVersion2 } from '@ifca-root/react-component/src/utils/hooks/excelUploadVersion2'
import { uuid } from 'uuidv4'

export interface BillItemProps {
  Name: string
  Description: string
  TaxSchemeID: string
  MasterCOAID: string
  AmorItem: boolean
  TaxRate: number
  einv_integrated: boolean
  einvoice_msic_code_id: string
  einvoice_classification_code_id: string
}

export const BillItemListing = (props: any) => {
  const getSearch = localStorage?.getItem('searchFilter')
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  let history = useHistory()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const { filteredList, handleSearch, setOriginalListing } = useFuseSearch()
  const {
    anchorEl,
    menu,
    handleClick,
    handleClose,
    resetMenu,
  } = useMenuOption()
  const [billItemDia, setBillItemDia] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isView, setIsView] = useState(false)
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  const { CompanyID }: any = useParams()
  const eInvoiceSubscriber = JSON.parse(
    localStorage.getItem('eInvoiceSubscriber')
  )
  const [TotalLength, setTotalLength] = useState(0)
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)
  const scheduledBillingEnv = !![
    'local',
    'azure',
    'internal',
    'axifcadev',
  ].includes(process.env.REACT_APP_LOCAL_DB)
  const [openUpload, setOpenUpload] = useState(false)
  const { handlePermDisabled } = usePermissionChecker()
  const BatchID = uuid()

  const BillItemSchema = yup.object().shape({
    Name: CommonYupValidation.requireField(SystemMsgs.name()),
    Description: CommonYupValidation.requireField(SystemMsgs.description()),
    TaxSchemeID: CommonYupValidation.requireField('Tax Code is required'),
    MasterCOAID: CommonYupValidation.requireField(
      'GL Account Code is required'
    ),
    einvoice_msic_code_id: yup.string().when('einv_integrated'.toString(), {
      is: true,
      then: yup.string().required(SystemMsgs?.MSICCode()),
      otherwise: yup.string().nullable(),
    }),
    einvoice_classification_code_id: yup
      .string()
      .when('einv_integrated'.toString(), {
        is: true,
        then: yup.string().required(SystemMsgs.ClassificationCode()),
        otherwise: yup.string().nullable(),
      }),
  })

  const {
    handleSubmit,
    control,
    register,
    setValue,
    watch,
    setError,
    clearErrors,
    errors,
    reset,
  } = useForm<BillItemProps>({
    mode: 'onSubmit',
    resolver: yupResolver(BillItemSchema),
  })

  const {
    openFileUpload,
    setOpenFileUpload,
    fileTitle,
    setFileTitle,
    openSnackBar,
    //setOpenSnackBar,
    snackBarMessage,
    setSnackBarMessage,
    currentData,
    setCurrentData,
    onDownloadTemplate,
    onSelectFile,
    duplicateItems,
    errorDialog: duplicateErrorDia,
    setErrorDialog,
    resetFileUpload,
    // setOpenSnackBar,
  } = useExcelUploadVersion2()
  //.........Query............//
  const {
    loading,
    data: {
      loggedInUserProfile,
      getAccountPermission,
      getCompany: curCompany,
      getRolePermission,
    } = {
      loggedInUserProfile: null,
      getAccountPermission: [],
      getCompany: [],
      getRolePermission: [],
    },
  } = useGetHomeSummaryQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  /*
  const [
    loadData,
    {
      fetchMore,
      loading: BillItemLoading,
      error: BillItemError,
      data: { getBillItem, getBillItemCount } = {
        getBillItem: [],
        getBillItemCount: null,
      },
    },
  ] = useGetBillItemDataLazyQuery({ //// HighOrderResolver
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ getBillItem, getBillItemCount }) => {
      if (getBillItem?.length > 0) {
        setOriginalListing([...filteredList, ...getBillItem])
      }
      if (!!getBillItemCount) {
        setTotalLength(getBillItemCount)
      }
    },
  })
  */

  const [
    loadData,
    {
      loading: BillItemLoading,
      error: BillItemError,
      data: { getAllBillItem } = { getAllBillItem: {} },
    },
  ] = useGetAllBillItemLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ getAllBillItem }) => {
      if (getAllBillItem?.Data?.length > 0) {
        setOriginalListing([...filteredList, ...getAllBillItem?.Data])
      }

      if (!!getAllBillItem?.TotalLength) {
        setTotalLength(getAllBillItem?.TotalLength)
      }
    },
  })

  useEffect(() => {
    loadData({
      variables: {
        take: 30,
        skip: 0,
        ...(getSearch && { searchValue: getSearch }),
      },
    })
  }, [])

  const {
    loading: MasterCOALoading,
    data: { getMasterCOA } = { getMasterCOA: [] },
  } = useGetMasterCoaCodeQuery({
    fetchPolicy: 'network-only',
    variables: { IsLastNode: true },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })
  const masterCOAList = getMasterCOA?.filter(
    coa =>
      coa?.IsLastNode === true &&
      coa?.IsControl === false &&
      coa.AccountType !== AccountType.Statistic &&
      coa.AccountType !== AccountType.MarketSegment
  )

  const {
    loading: TaxLoading,
    data: { getTaxSchemeListing } = { getTaxSchemeListing: [] },
  } = useGetTaxSchemeNewListingQuery({
    variables: {
      TaxClass: 'OUTPUT',
      CommonStatus: CommonStatus.Active,
    },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  //.........Mutation............//

  const [
    createBillItem,
    { loading: CreateLoading },
  ] = useCreateBillItemMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: data => {
      setBillItemDia(false)
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.createNewRecord())
      setOriginalListing([])
      loadData({
        variables: {
          skip: 0,
          take: 30,
          ...(getSearch && { searchValue: getSearch }),
        },
      })
    },
  })

  const [
    updateBillItem,
    { loading: UpdateLoading },
  ] = useUpdateBillItemMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: data => {
      setBillItemDia(false)
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.updateRecord())
      setOriginalListing([])
      loadData({
        variables: {
          skip: 0,
          take: 30,
          ...(getSearch && { searchValue: getSearch }),
        },
      })
    },
  })

  const [
    deleteBillItem,
    { loading: DeleteBillItemLoading },
  ] = useDeleteBillItemMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: () => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.deleteRecord())
      setOriginalListing([])
      loadData({
        variables: {
          skip: 0,
          take: 30,
          ...(getSearch && { searchValue: getSearch }),
        },
      })
    },
  })

  const {
    loading: MSICCodeLoading,
    data: { getMSICCode } = { getMSICCode: [] },
  } = useGetMsicCodeQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: ClassificationCodeLoading,
    data: { getClassificationCode } = { getClassificationCode: [] },
  } = useGetClassificationCodeQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const [
    ImportBillItemExcel,
    { loading: ImportBillItemExcelLoading, error: createError },
  ] = useImportBillItemExcelMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
      resetFileUpload()
      setFileTitle('')
      setCurrentData([])
      setOpenUpload(false)
    },
    onCompleted: data => {
      resetFileUpload()
      setFileTitle('')
      setCurrentData([])
      setOpenUpload(false)
      history.push({
        pathname: `/account-receivable/general-setting/bill-items/import-bill-item-validation/${data?.ImportBillItemExcel}`,
        state: {
          BatchID: data?.ImportBillItemExcel,
          fileTitle: fileTitle,
        },
      })
    },
  })

  const [deleteError, setDeleteError] = useState(false)

  const [TaxRate, setTaxRate] = useState(0)

  const [selectedTax, setSelectedTax] = useState(
    !!menu ? menu?.obj?.TaxSchemeID : null
  )

  const taxEffectiveDate: any = new Date(new Date().getTime())
    .toISOString()
    .slice(0, 10)

  const filteredTaxScheme = getTaxSchemeListing?.filter(
    el =>
      el?.taxSchemeDetailList?.filter(y => {
        return new Date(y?.effectiveDate).toISOString() <= taxEffectiveDate
      })?.length > 0 && el?.commonStatus === 'ACTIVE'
  )

  const onSubmit = data => {
    isEdit === false
      ? createBillItem({
          variables: {
            input: {
              Name: data.Name,
              Description: data.Description,
              TaxSchemeID: data.TaxSchemeID,
              MasterCOAID: data.MasterCOAID,
              einv_integrated: data.einv_integrated,
              ...(data?.einv_integrated === true
                ? {
                    einvoice_msic_code_id: data.einvoice_msic_code_id,
                    einvoice_classification_code_id:
                      data.einvoice_classification_code_id,
                  }
                : null),
              TaxRate: TaxRate,
              ...(scheduledBillingEnv && { AmorItem: data?.AmorItem }),
            },
          },
          refetchQueries: [
            {
              query: GetBillItemDataDocument,
              variables: { skip: 0, take: 30 },
            },
          ],
        })
      : updateBillItem({
          variables: {
            input: {
              BillItemID: menu?.ID,
              Name: data.Name,
              Description: data.Description,
              TaxSchemeID: data.TaxSchemeID,
              MasterCOAID: data.MasterCOAID,
              einv_integrated: data.einv_integrated,
              ...(data?.einv_integrated === true
                ? {
                    einvoice_msic_code_id: data.einvoice_msic_code_id,
                    einvoice_classification_code_id:
                      data.einvoice_classification_code_id,
                  }
                : {
                    einvoice_msic_code_id: null,
                    einvoice_classification_code_id: null,
                  }),
              TaxRate: TaxRate,
              ...(scheduledBillingEnv && { AmorItem: data?.AmorItem }),
            },
          },
          refetchQueries: [
            {
              query: GetBillItemDataDocument,
              variables: { skip: 0, take: 30 },
            },
          ],
        })
    clearErrors()
  }

  const InactiveReactive = status => {
    updateBillItem({
      variables: {
        input: {
          BillItemID: menu?.ID,
          Name: menu?.obj.Name,
          Description: menu?.obj.Description,
          TaxSchemeID: menu?.obj.TaxSchemeID,
          MasterCOAID: menu?.obj.MasterCOAID,
          einv_integrated: menu?.obj.einv_integrated,
          einvoice_msic_code_id: menu?.obj.einvoice_msic_code_id,
          einvoice_classification_code_id:
            menu?.obj.einvoice_classification_code_id,
          RecordStatus: status,
          TaxRate: TaxRate,
          AmorItem: menu?.obj.AmorItem,
        },
      },
      refetchQueries: [
        { query: GetBillItemDataDocument, variables: { skip: 0, take: 30 } },
      ],
    })
  }

  const handleDelete = () => {
    deleteBillItem({
      variables: { input: { BillItemID: menu?.obj?.BillItemID } },
      refetchQueries: [
        { query: GetBillItemDocument, variables: { skip: 0, take: 30 } },
      ],
    })
    setOpenDeleteDialog(false)
  }

  //to make delay for search function for the query to load

  const [timer, setTimer] = useState(null)
  function changeDelay(change) {
    if (timer) {
      clearTimeout(timer)
      setTimer(null)
    }

    setTimer(
      setTimeout(() => {
        setOriginalListing([])
        loadData({ variables: { skip: 0, take: 30, searchValue: change } })
      }, 1000)
    )
  }

  const onImport = data => {
    ImportBillItemExcel({
      variables: {
        BatchID: BatchID,
        BillItemExcelImportInput: data?.map(x => {
          return {
            BatchID: BatchID,
            Name: x?.Name === '' ? null : `${x?.Name}`,
            Description: x?.Description === '' ? null : `${x?.Description}`,
            TaxSchemeName:
              x?.TaxSchemeName === '' ? null : `${x?.TaxSchemeName}`,
            MasterCOACode:
              x?.GLAccountCode === '' ? null : `${x?.GLAccountCode}`,
            EInvoice:
              x?.['e-Invoice'] === 'true' ||
              x?.['e-Invoice'] === 'True' ||
              x?.['e-Invoice'] === 'TRUE' ||
              x?.['e-Invoice'] === 'Yes'
                ? true
                : x?.['e-Invoice'] === 'false' ||
                  x?.['e-Invoice'] === 'False' ||
                  x?.['e-Invoice'] === 'FALSE' ||
                  x?.['e-Invoice'] === 'No' ||
                  x?.['e-Invoice'] === ''
                ? false
                : x?.['e-Invoice'],
            MSICCode: x?.MSICCode === '' ? null : `${x?.MSICCode}`,
            ClassificationCode:
              x?.ClassificationCode === '' ? null : `${x?.ClassificationCode}`,
            RowNo: x?.rowNo,
          }
        }),
      },
    })
  }

  return (
    <>
      {loading && <Loading />}
      {TaxLoading && <Loading />}
      {CreateLoading && <Loading />}
      {UpdateLoading && <Loading />}
      {BillItemLoading && <Loading />}
      {MSICCodeLoading && <Loading />}
      {MasterCOALoading && <Loading />}
      {DeleteBillItemLoading && <Loading />}
      {ClassificationCodeLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          localStorage.removeItem('searchFilter')
          history.push(`/account-receivable/general-setting`)
        }} //<- back button action
        smTitle={'Account Receivable'}
        title={user?.accountName}
        routeSegments={[{ name: 'AR' }, { name: 'Bill Items', current: true }]}
      />
      <div className="search-filter with-dropdown-filter ">
        <SearchHeader
          title="Bill Items"
          value={`${TotalLength}`}
          search
          onChangeAction={e => {
            // handleSearch(e?.target?.value, ['Name', 'Description'])
            localStorage.setItem('searchFilter', e.target.value)
            changeDelay(e.target.value)
          }}
          onCloseAction={() => {
            handleSearch('', [])
            localStorage.removeItem('searchFilter')
            setOriginalListing([])
            loadData({ variables: { skip: 0, take: 30 } })
          }}
          isDefaultValue={!!getSearch}
          defaultValue={getSearch ?? ''}
        />
      </div>
      <ContentWrapper footer overflow>
        <div className="message-alert text-noflow">
          <div className="flex-space">
            <IconText
              icon={
                <img
                  src={ExcelIcon}
                  style={{ width: '19px', paddingRight: '5px' }}
                />
              }
              font="mdDesc"
              children={
                <>
                  <span style={{ fontWeight: 'bold' }}>Upload </span>{' '}
                  <span>Bill Item excel list</span>
                </>
              }
            ></IconText>
          </div>
          <div>
            <span>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                style={{
                  minWidth: '0px',
                  width: '32px',
                  height: '24px',
                  margin: '-2px 0px -2px 0px',
                }}
                onClick={() => setOpenUpload(true)}
              >
                {<UploadIcon style={{ width: '17px', height: '17px' }} />}
              </Button>
            </span>
          </div>
        </div>
        <List className="core-list">
          {filteredList === undefined || filteredList?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={filteredList?.length}
              next={() => {
                const currentLength = filteredList?.length
                loadData({
                  variables: {
                    skip: currentLength,
                    take: 30,
                    searchValue: getSearch === '' ? undefined : getSearch,
                  },
                })
              }}
              hasMore={true}
              style={{ padding: '8px 6px' }}
              loader={
                BillItemLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {filteredList?.map((el, index) => {
                return (
                  <ListItem selected={el.RecordStatus === 'INACTIVE'}>
                    <ListItemText
                      primary={
                        <>
                          <span className="xsTitle flex-space">{el?.Name}</span>
                        </>
                      }
                      secondary={
                        <>
                          <Grid container>
                            <Grid item xs={12}>
                              <span className="desc ">
                                {el?.MasterCOA?.Code} | {el?.MasterCOA?.Name}
                              </span>
                            </Grid>
                            <Grid item xs={12}>
                              <span className="desc">
                                {el?.TaxScheme?.Code}
                                {!!el?.einv_integrated
                                  ? ` | ${
                                      getMSICCode?.find(
                                        x => x?.id === el?.einvoice_msic_code_id
                                      )?.description
                                    } (${
                                      getMSICCode?.find(
                                        x => x?.id === el?.einvoice_msic_code_id
                                      )?.msicCode
                                    }) | ${
                                      getClassificationCode?.find(
                                        x =>
                                          x?.id ===
                                          el?.einvoice_classification_code_id
                                      )?.description
                                    } (${
                                      getClassificationCode?.find(
                                        x =>
                                          x?.id ===
                                          el?.einvoice_classification_code_id
                                      )?.classificationCode
                                    })`
                                  : null}
                              </span>
                            </Grid>
                          </Grid>
                        </>
                      }
                    />
                    <ListItemSecondaryAction>
                      <IconButton
                        edge="end"
                        aria-label="more"
                        aria-controls="menu-list"
                        aria-haspopup="true"
                        onClick={e => {
                          handleClick(e, el.BillItemID, index, el)
                          register('Name')
                          register('Description')
                          register('MasterCOAID')
                          register('TaxSchemeID')
                          register('einv_integrated')
                          register('einvoice_classification_code_id')
                          register('einvoice_msic_code_id')
                          setValue('Name', el?.Name)
                          setValue('Description', el?.Description)
                          setValue('MasterCOAID', el?.MasterCOAID)
                          setValue('TaxSchemeID', el?.TaxSchemeID)
                          setValue('einv_integrated', el?.einv_integrated)
                          if (el?.einv_integrated) {
                            setValue(
                              'einvoice_classification_code_id',
                              el?.einvoice_classification_code_id
                            )
                            setValue(
                              'einvoice_msic_code_id',
                              el?.einvoice_msic_code_id
                            )
                          }
                        }}
                      >
                        <MoreVert />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                )
              })}
            </InfiniteScroll>
          )}
        </List>
        <FloatButton
          onClick={() => {
            setIsView(false)
            setIsEdit(false)
            resetMenu()
            setBillItemDia(true)
          }}
        />
      </ContentWrapper>
      <Menu
        id="menu-list"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
      >
        <MenuItem
          onClick={() => {
            setIsView(true)
            setIsEdit(false)
            setBillItemDia(true)
          }}
        >
          View
        </MenuItem>
        {menu?.obj?.RecordStatus === RecordStatus.Active ? (
          <>
            <MenuItem
              onClick={() => {
                // setValue('TaxSchemeID', menu?.obj?.TaxSchemeID)
                // setValue('MasterCOAID', menu?.obj?.MasterCOAID)
                setIsView(false)
                setIsEdit(true)
                setBillItemDia(true)
              }}
              disabled={handlePermDisabled({
                permEnum:
                  AcctPermission.AccReceivableGeneralSettingsBillItemUpdate,
              })}
            >
              Edit
            </MenuItem>
            <MenuItem
              onClick={() => InactiveReactive(RecordStatus.Inactive)}
              disabled={handlePermDisabled({
                permEnum:
                  AcctPermission.AccReceivableGeneralSettingsBillItemInactive,
              })}
            >
              Inactive
            </MenuItem>
          </>
        ) : (
          <MenuItem
            onClick={() => InactiveReactive(RecordStatus.Active)}
            disabled={handlePermDisabled({
              permEnum:
                AcctPermission.AccReceivableGeneralSettingsBillItemInactive,
            })}
          >
            Reactive
          </MenuItem>
        )}

        {/*
        <MenuItem
          onClick={() => setOpenDeleteDialog(true)}
          disabled={menu?.obj?.IsUsed ? true : false}
        >
          <span>Delete</span>
        </MenuItem>
        */}
      </Menu>
      <Box mt={1}>
        <CommonDialog
          fullWidth={true}
          open={billItemDia}
          onClose={() => {
            reset()
            setBillItemDia(false)
          }}
          sections={{
            header: {
              dynamic: (
                <div>
                  <div className="dialog-dynamic-content">
                    <div className="session">
                      <div className="flex session">
                        <div
                          className="dialog-title flex-space"
                          style={{
                            fontSize: '12px',
                            fontWeight: 'bold',
                            color: 'orange',
                          }}
                        >
                          {'Bill Item'}
                        </div>
                        {isEdit === false && isView === true && (
                          <div
                            className="dialog-title right-text"
                            style={{
                              fontSize: '12px',
                              fontWeight: 'bold',
                              color: 'orange',
                            }}
                          >
                            {'View'}
                          </div>
                        )}
                        {isEdit === false && isView === false && (
                          <div
                            className="dialog-title right-text"
                            style={{
                              fontSize: '12px',
                              fontWeight: 'bold',
                              color: 'orange',
                            }}
                          >
                            {'New'}
                          </div>
                        )}
                        {isEdit === true && isView === false && (
                          <div
                            className="dialog-title right-text"
                            style={{
                              fontSize: '12px',
                              fontWeight: 'bold',
                              color: 'orange',
                            }}
                          >
                            {'Edit'}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ),
            },
            body: () => {
              if (isView === false) {
                return (
                  <>
                    <div className="content-container">
                      <Controller
                        as={TextField}
                        name="Name"
                        required
                        label="Name"
                        control={control}
                        ref={register}
                        defaultValue={menu?.obj?.Name}
                        helperText={errors?.Name?.message}
                        error={errors?.Name ? true : false}
                      />
                      <Controller
                        as={TextField}
                        name="Description"
                        required
                        label="Description"
                        control={control}
                        ref={register}
                        defaultValue={menu?.obj?.Description}
                        helperText={errors?.Description?.message}
                        error={errors?.Description ? true : false}
                      />
                      <Controller
                        control={control}
                        name="TaxSchemeID"
                        ref={register()}
                        defaultValue={menu?.obj?.TaxSchemeID}
                        onChange={({ value, newValue }) => {
                          return newValue?.TaxSchemeID
                        }}
                        helperText={errors?.TaxSchemeID?.message}
                        error={errors?.TaxSchemeID ? true : false}
                        render={({ onChange, onBlur, value }) => {
                          const defVal = filteredTaxScheme?.filter(
                            x => x?.id === menu?.obj?.TaxSchemeID
                          )[0]
                          return (
                            <Autocomplete
                              className="mat-new"
                              defaultValue={defVal}
                              options={
                                filteredTaxScheme?.sort((a, b) => {
                                  return a.name.localeCompare(b.name)
                                }) || []
                              }
                              getOptionLabel={option =>
                                `${option?.name} | ${option?.description} ${
                                  option?.isExclusive ? `(E)` : `(I)`
                                }`
                              }
                              fullWidth
                              renderOption={(props, option) => (
                                <>
                                  <div>
                                    <div>
                                      <span className="xsTitle">
                                        {props?.name}
                                      </span>
                                    </div>
                                    <div className="desc">
                                      {props?.description}{' '}
                                      {props?.isExclusive ? `(E)` : `(I)`}
                                    </div>
                                  </div>
                                </>
                              )}
                              onChange={(value, newValue: any) => {
                                onChange(newValue?.id)
                              }}
                              PopperComponent={AccCodeDropdownFullWidth}
                              renderInput={(params: any) => {
                                return (
                                  <TextField
                                    {...params}
                                    InputLabelProps={{ shrink: true }}
                                    label="Tax Scheme"
                                    helperText={errors?.TaxSchemeID?.message}
                                    error={errors?.TaxSchemeID ? true : false}
                                    required
                                  />
                                )
                              }}
                            />
                          )
                        }}
                      />
                      <Controller
                        control={control}
                        name="MasterCOAID"
                        ref={register()}
                        defaultValue={menu?.obj?.MasterCOAID}
                        onChange={({ value, newValue }) => {
                          return newValue?.MasterCOAID
                        }}
                        helperText={errors?.MasterCOAID?.message}
                        error={errors?.MasterCOAID ? true : false}
                        render={({ onChange, onBlur, value }) => {
                          const defVal = masterCOAList?.filter(
                            x => x?.MasterCOAID === menu?.obj?.MasterCOAID
                          )[0]
                          return (
                            <Autocomplete
                              className="mat-new"
                              defaultValue={defVal}
                              options={
                                masterCOAList?.sort((a, b) => {
                                  return a.Code.localeCompare(b.Code)
                                }) || []
                              }
                              getOptionLabel={option =>
                                `${option?.Code} | ${option?.Name}`
                              }
                              fullWidth
                              renderOption={(props, option) => (
                                <>
                                  <div>
                                    <div>
                                      <span className="xsTitle">
                                        {props?.Code}
                                      </span>
                                    </div>
                                    <div className="desc">{props?.Name}</div>
                                  </div>
                                </>
                              )}
                              onChange={(value, newValue: any) => {
                                onChange(newValue?.MasterCOAID)
                              }}
                              PopperComponent={AccCodeDropdownFullWidth}
                              renderInput={(params: any) => {
                                return (
                                  <TextField
                                    {...params}
                                    InputLabelProps={{ shrink: true }}
                                    label="GL Account  Code"
                                    //defaultValue={defVal?.Code}
                                    helperText={errors?.MasterCOAID?.message}
                                    error={errors?.MasterCOAID ? true : false}
                                    required
                                  />
                                )
                              }}
                            />
                          )
                        }}
                      />
                      {eInvoiceSubscriber && (
                        <>
                          <div
                            className="content-wrap full"
                            style={{
                              justifyContent: 'space-between',
                              display: 'flex',
                            }}
                          >
                            <span
                              className="flex-space"
                              style={{ alignContent: 'center' }}
                            >
                              e-Invoice
                            </span>
                            <Switch
                              onChange={e => {}}
                              name="einv_integrated"
                              color="primary"
                              inputRef={register()}
                              defaultChecked={
                                !!isEdit ? menu?.obj?.einv_integrated : false
                              }
                            />
                          </div>

                          {watch('einv_integrated') === true && (
                            <>
                              {!MSICCodeLoading && (
                                <Controller
                                  render={({ value, onChange }) => {
                                    let defVal = getMSICCode?.filter(
                                      coa =>
                                        coa?.id ===
                                        menu?.obj?.einvoice_msic_code_id
                                    )[0]

                                    return (
                                      <Autocomplete
                                        options={
                                          getMSICCode?.sort((a, b) => {
                                            return a?.msicCode.localeCompare(
                                              b?.msicCode
                                            )
                                          }) || []
                                        }
                                        getOptionLabel={option =>
                                          `${option?.msicCode} (${option?.description})`
                                        }
                                        fullWidth
                                        onChange={(value, newValue: any) => {
                                          onChange(newValue?.id)
                                        }}
                                        PopperComponent={
                                          AccCodeDropdownFullWidth
                                        }
                                        renderOption={(props, option) => {
                                          return (
                                            <div className="content-wrap full">
                                              <div>
                                                <span className="xsTitle">
                                                  {props?.msicCode}
                                                </span>
                                              </div>
                                              <div className="desc">
                                                {props?.description}
                                              </div>
                                            </div>
                                          )
                                        }}
                                        defaultValue={defVal}
                                        renderInput={(params: any) => {
                                          return (
                                            <div>
                                              <TextField
                                                {...params}
                                                helperText={
                                                  errors?.einvoice_msic_code_id
                                                    ?.message
                                                }
                                                error={
                                                  errors?.einvoice_msic_code_id
                                                    ? true
                                                    : false
                                                }
                                                label="MSIC Code"
                                                style={{ width: '100%' }}
                                                InputLabelProps={
                                                  defVal
                                                    ? { shrink: true }
                                                    : null
                                                }
                                                margin="dense"
                                                variant="standard"
                                                required
                                              />
                                            </div>
                                          )
                                        }}
                                      />
                                    )
                                  }}
                                  label="MSIC Code"
                                  name="einvoice_msic_code_id"
                                  autoComplete="off"
                                  control={control}
                                  multiline={true}
                                  fullWidth
                                  margin="dense"
                                  ref={register}
                                  helperText={
                                    errors?.einvoice_msic_code_id?.message
                                  }
                                  error={
                                    errors?.einvoice_msic_code_id ? true : false
                                  }
                                  defaultValue={
                                    isEdit
                                      ? menu?.obj?.einvoice_msic_code_id
                                      : ''
                                  }
                                />
                              )}

                              {!ClassificationCodeLoading && (
                                <Controller
                                  render={({ value, onChange }) => {
                                    let defVal = getClassificationCode?.filter(
                                      coa =>
                                        coa?.id ===
                                        menu?.obj
                                          ?.einvoice_classification_code_id
                                    )[0]

                                    return (
                                      <Autocomplete
                                        options={
                                          getClassificationCode?.sort(
                                            (a, b) => {
                                              return a?.classificationCode.localeCompare(
                                                b?.classificationCode
                                              )
                                            }
                                          ) || []
                                        }
                                        getOptionLabel={option =>
                                          `${option?.classificationCode} (${option?.description})`
                                        }
                                        fullWidth
                                        onChange={(value, newValue: any) => {
                                          onChange(newValue?.id)
                                        }}
                                        PopperComponent={
                                          AccCodeDropdownFullWidth
                                        }
                                        renderOption={(props, option) => {
                                          return (
                                            <div className="content-wrap full">
                                              <div>
                                                <span className="xsTitle">
                                                  {props?.classificationCode}
                                                </span>
                                              </div>
                                              <div className="desc">
                                                {props?.description}
                                              </div>
                                            </div>
                                          )
                                        }}
                                        defaultValue={defVal}
                                        renderInput={(params: any) => {
                                          return (
                                            <div>
                                              <TextField
                                                {...params}
                                                helperText={
                                                  errors
                                                    ?.einvoice_classification_code_id
                                                    ?.message
                                                }
                                                error={
                                                  errors?.einvoice_classification_code_id
                                                    ? true
                                                    : false
                                                }
                                                label="Classification Code"
                                                style={{ width: '100%' }}
                                                InputLabelProps={
                                                  defVal
                                                    ? { shrink: true }
                                                    : null
                                                }
                                                margin="dense"
                                                variant="standard"
                                                required
                                              />
                                            </div>
                                          )
                                        }}
                                      />
                                    )
                                  }}
                                  label="Classification Code"
                                  name="einvoice_classification_code_id"
                                  autoComplete="off"
                                  control={control}
                                  multiline={true}
                                  fullWidth
                                  margin="dense"
                                  ref={register}
                                  helperText={
                                    errors?.einvoice_classification_code_id
                                      ?.message
                                  }
                                  error={
                                    errors?.einvoice_classification_code_id
                                      ? true
                                      : false
                                  }
                                  defaultValue={
                                    isEdit
                                      ? menu?.obj
                                          ?.einvoice_classification_code_id
                                      : ''
                                  }
                                />
                              )}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </>
                )
              } else {
                const taxScheme = filteredTaxScheme?.find(
                  x => x?.id === menu?.obj?.TaxSchemeID
                )
                const masterCOA = masterCOAList?.find(
                  x => x?.MasterCOAID === menu?.obj?.MasterCOAID
                )
                const MSICCode = getMSICCode?.find(
                  coa => coa?.id === menu?.obj?.einvoice_msic_code_id
                )
                const classificationCode = getClassificationCode?.find(
                  coa => coa?.id === menu?.obj?.einvoice_classification_code_id
                )

                return (
                  <>
                    <div className="content-wrap full">
                      <div className="desc c-grey">Name</div>
                      <div className="mdDesc">{menu?.obj?.Name}</div>
                    </div>
                    <div className="content-wrap full">
                      <div className="desc c-grey">Description</div>
                      <div className="mdDesc">{menu?.obj?.Description}</div>
                    </div>
                    <div className="content-wrap full">
                      <div className="desc c-grey">Tax Scheme</div>
                      <div className="mdDesc">
                        {taxScheme
                          ? `${taxScheme.name} | ${taxScheme.description} ${
                              taxScheme.isExclusive ? `(E)` : `(I)`
                            }`
                          : `None`}
                        {/* {`
                        ${filteredTaxScheme?.find(x => x?.id === menu?.obj?.TaxSchemeID)?.name} | ${filteredTaxScheme?.filter(x => x?.id === menu?.obj?.TaxSchemeID)[0]?.description} ${filteredTaxScheme?.filter(x => x?.id === menu?.obj?.TaxSchemeID)[0]?.isExclusive ? `(E)` : `(I)`}
                        `} */}
                      </div>
                    </div>
                    <div className="content-wrap full">
                      <div className="desc c-grey">GL Account Code</div>
                      <div className="mdDesc">
                        {masterCOA
                          ? `${masterCOA.Code} | ${masterCOA.Name}`
                          : `None`}
                      </div>
                    </div>
                    <div className="content-wrap full">
                      <div className="desc c-grey">e-Invoice</div>
                      <div className="mdDesc">
                        {menu?.obj?.einv_integrated ? 'Yes' : 'No'}
                      </div>
                    </div>
                    {menu?.obj?.einv_integrated && (
                      <>
                        <div className="content-wrap full">
                          <div className="desc c-grey">MSIC Code</div>
                          <div className="mdDesc">
                            {MSICCode
                              ? `${MSICCode.msicCode} (${MSICCode.description})`
                              : `None`}
                          </div>
                        </div>
                        <div className="content-wrap full">
                          <div className="desc c-grey">Classification Code</div>
                          <div className="mdDesc">
                            {classificationCode
                              ? `${classificationCode.classificationCode} (${classificationCode.description})`
                              : `None`}
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )
              }
            },
            footer: {
              actions:
                isView === false
                  ? [
                      {
                        displayText: 'Cancel',
                        props: {
                          onClick: () => {
                            reset()
                            setBillItemDia(false)
                          },
                          variant: 'contained',
                          color: 'primary',
                        },
                      },
                      {
                        displayText: 'Confirm',
                        props: {
                          onClick: () => {
                            handleSubmit(onSubmit)()
                          },
                          variant: 'contained',
                          color: 'primary',
                          form: 'createUOM-form',
                          type: 'submit',
                        },
                      },
                    ]
                  : [
                      {
                        displayText: 'Close',
                        props: {
                          onClick: () => {
                            reset()
                            setBillItemDia(false)
                          },
                          variant: 'contained',
                          color: 'primary',
                        },
                      },
                    ],
            },
          }}
        />
      </Box>
      <CommonDialog
        fullWidth={true}
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
        sections={{
          header: {
            title: `Item`,
            rightText: 'Delete',
            infoLine: menu?.obj?.Name,
          },
          body: () => (
            <div className="content-wrap full">
              <span className="mdDesc full">Confirm to delete?</span>
            </div>
          ),
          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => setOpenDeleteDialog(false),
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => handleDelete(),
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
      <CommonDialog
        fullWidth={true}
        open={deleteError}
        onClose={() => setDeleteError(false)}
        sections={{
          header: {
            children: (
              <ListItem className="remove-padding">
                <ListItemText
                  primary={
                    <>
                      <span
                        className="xsTitle flex-space"
                        style={{ color: 'red' }}
                      >
                        Error!
                      </span>
                    </>
                  }
                />
              </ListItem>
            ),
          },
          body: () => (
            <div>
              <span className="text-noflow mdDesc">{`You are not allowed to delete this bill item as it's already been used`}</span>
            </div>
          ),
          footer: {
            actions: [
              {
                displayText: 'Close',
                props: {
                  onClick: () => {
                    setDeleteError(false)
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
      <ItemExcelInput
        showDupErrors={false}
        duplicateItems={duplicateItems}
        errorDia={duplicateErrorDia}
        setErrorDia={setErrorDialog}
        openUpload={openUpload}
        setOpenUpload={setOpenUpload}
        upload={fileTitle}
        template={currentData}
        setTemplate={setCurrentData}
        setUpload={setFileTitle}
        resetFileUpload={resetFileUpload}
        showFooter={false}
        reUpload={true}
        isBillItem={true}
        onUploadTemplate={() => {
          onImport(currentData)
          setOpenUpload(false)
        }}
        onSelectFile={(e: any) => {
          onSelectFile({ event: e })
        }}
        onDownloadTemplate={onDownloadTemplate}
        snackBarProps={{
          openSnackBar: openSnackBar,
          snackBarMessage: 'test',
          setOpenSnackBar: setOpenSnackBar,
          onClickButton: () => {
            setOpenSnackBar(false)
          },
        }}
      />
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
